module.exports = __webpack_public_path__ + "static/media/16.4df5a9e2.jpeg";